export const RequiresAaOnboardingTemplates = {
  ENTERPRISE: 'enterprise',
  INACTIVE: 'inactive',
  DOMAIN_CLAIM: 'domainClaim',
  NEWLY_MANAGED: 'newlyManaged',
};
